import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=2adb6a00&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=ts"
export * from "./Tasks.vue?vue&type=script&lang=ts"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=2adb6a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adb6a00",
  null
  
)

export default component.exports